module.exports = __webpack_public_path__ + "static/media/door-hanger.25cf2081.png";